import { E_ROUTER_NAME, E_ROUTER_PARAMS } from '@pharmsnap/pharmsnap-web/types/enum'
import { IAutoCompleteType, IExampleTag } from '@pharmsnap/shared/types'
import { Dictionary } from 'vue-router/types/router'

export type IViewDetailVal = {
  name: E_ROUTER_NAME
  paramId: E_ROUTER_PARAMS
  query?: Dictionary<string | (string | null)[] | null | undefined> | undefined
}

export type IExampleConfigKey =
  | 'DrugFinder'
  | 'ClinicalFinder'
  | 'PatentFinder'
  | 'LiteratureFinder'
  | 'ClinicalResultFinder'
  | 'DrugDealFinder'
  | 'TranslationalMedicineFinder'

export const viewDetailConfig: Partial<Record<IAutoCompleteType, IViewDetailVal>> = {
  Drug: {
    name: E_ROUTER_NAME.DRUG,
    paramId: E_ROUTER_PARAMS.DRUG_ID,
  },
  Disease: {
    name: E_ROUTER_NAME.DISEASE,
    paramId: E_ROUTER_PARAMS.DISEASE_ID,
  },
  Target: {
    name: E_ROUTER_NAME.TARGET,
    paramId: E_ROUTER_PARAMS.TARGET_ID,
  },
  Organization: {
    name: E_ROUTER_NAME.ORGANIZATION,
    paramId: E_ROUTER_PARAMS.ORG_ID,
  },
  DrugType: {
    name: E_ROUTER_NAME.DRUG_TYPE,
    paramId: E_ROUTER_PARAMS.DRUG_TYPE_ID,
  },
}

const DrugExampleConfig = {
  Pembrolizumab: {
    id: '945fa31ebe9e41ae912e493aa3324576',
    display_name_en: 'Pembrolizumab',
    display_name_cn: '帕博利珠单抗',
    icon: 'Drug',
  },
  Nivolumab: {
    id: 'f3b0ae0fb4df40469b0ba4cbaadc3a21',
    display_name_en: 'Nivolumab',
    display_name_cn: '纳武利尤单抗',
    icon: 'Drug',
  },
  Trastuzumab: {
    id: 'fcaf760bd0d54f5ca79c92ca47466fe7',
    display_name_en: 'Trastuzumab',
    display_name_cn: '曲妥珠单抗',
    icon: 'Drug',
  },
  BrentuximabVedotin: {
    id: 'd3e71cccacd44b44bf9029184d7c485d',
    display_name_en: 'Brentuximab Vedotin',
    display_name_cn: '维布妥昔单抗',
    icon: 'Drug',
  },
  VutrisiranSodium: {
    id: '7639fca066e84dd787309c88ccac414e',
    display_name_en: 'Vutrisiran Sodium',
    display_name_cn: 'Vutrisiran Sodium',
    icon: 'Drug',
  },
}

const OrgExampleConfig = {
  Roche: {
    id: '87bfaf037f8e60c9e25595cd98bb27e4',
    display_name_en: 'Roche',
    display_name_cn: '罗氏',
  },
  Pfizer: {
    id: '9597e75ba30c9958d4331f586407d7cf',
    display_name_en: 'Pfizer',
    display_name_cn: '辉瑞',
  },
  LegendBiotechUSA: {
    id: '336e7d3b6f91616c632bc60c40a434de',
    display_name_en: 'Legend Biotech USA, Inc.',
    display_name_cn: 'Legend Biotech USA, Inc.',
  },
  Johnson: {
    id: 'fa85404e9b2f62d55e5167ed2213eca7',
    display_name_en: 'Johnson & Johnson',
    display_name_cn: '美国强生公司',
  },
  IonisPharmaceuticals: {
    id: '26fccb4d7b5089cb0283d61fe43aa242',
    display_name_en: 'Ionis Pharmaceuticals, Inc.',
    display_name_cn: 'Ionis Pharmaceuticals, Inc.',
  },
}

const TargetExampleConfig = {
  PD1: {
    id: '9786d32e3d244a688ec6a60d2fe1b10b',
    display_name_en: 'PD-1',
    display_name_cn: 'PD-1',
  },
  PD_L1: {
    id: '06c7ab146b884a3aa890cfd1a4a0e168',
    display_name_en: 'PD-L1',
    display_name_cn: 'PD-L1',
  },
  HER2: {
    id: 'a3c3158483984ff9922b1b0ba939a068',
    display_name_en: 'HER2',
    display_name_cn: 'HER2',
  },
  TLR9: {
    id: '195c6a755b874e61b231e61b758ad71c',
    display_name_en: 'TLR9',
    display_name_cn: 'TLR9',
  },
  CD30: {
    id: 'cb6691e57fe94b2b834e78f94a4d9eb9',
    display_name_en: 'CD30',
    display_name_cn: 'CD30',
  },
  Tubulin: {
    id: 'd9461748c4c54a0b84cbad2ae3fce7d5',
    display_name_en: 'Tubulin',
    display_name_cn: 'Tubulin',
  },
}

const DiseaseExampleConfig = {
  LungCancer: {
    id: 'e2fd9bda4aeb4a7b9fa53a2560126d24',
    display_name_en: 'Lung Cancer',
    display_name_cn: '肺癌',
  },
  BreastCancer: {
    id: 'f319fa27684c4cdeb6ce59d897217718',
    display_name_en: 'Breast Cancer',
    display_name_cn: '乳腺癌',
  },
  MuscularDystrophy: {
    id: '3edeea348eb24d8d8fbf0cccd058f464',
    display_name_en: 'Muscular Dystrophy, Duchenne',
    display_name_cn: '杜氏肌营养不良症',
  },
}

const DrugTypeExampleConfig = {
  ASO: {
    id: '1f455eba74a44f2eb2c710eaede94571',
    display_name_en: 'ASO',
    display_name_cn: '反义寡核苷酸',
  },
  ADC: {
    id: '6be383aaee904d2b8321e2d1fdacf8bb',
    display_name_en: 'ADC',
    display_name_cn: 'ADC',
  },
}

export const ExampleConfig = {
  drug: DrugExampleConfig,
  org: OrgExampleConfig,
  target: TargetExampleConfig,
  disease: DiseaseExampleConfig,
  drugType: DrugTypeExampleConfig,
}

const baseExampleTagConfig: Record<Extract<IAutoCompleteType, 'Core' | 'Drug' | 'Organization' | 'Target' | 'Disease' | 'DrugType'>, IExampleTag> = {
  Core: {
    display_name_en: 'CRISPR',
    display_name_cn: 'CRISPR',
  },
  Drug: {
    id: '2838b95ade834c96b17ac8bcd2b68c27',
    display_name_en: 'Sotorasib',
    display_name_cn: '索托拉西布',
    icon: 'Drug',
  },
  Organization: {
    id: '11ef8a9e8bf5ca80213a1183511cded3',
    display_name_en: 'Amgen, Inc.',
    display_name_cn: '安进',
    icon: 'Tree',
  },
  Target: {
    id: '928facc8122849baa0dc00759cff0380',
    display_name_en: 'KRAS G12C',
    display_name_cn: 'KRAS G12C',
    icon: 'Tree',
  },
  Disease: {
    id: '3beea980d93a4cc0abc864e27514601c',
    display_name_en: 'NSCLC',
    display_name_cn: '非小细胞肺癌',
    icon: 'Tree',
  },
  DrugType: {
    id: '9a847883d786485489d0ee1d75ae90ba',
    display_name_en: 'Bispecific antibody',
    display_name_cn: '双特异性抗体',
    icon: 'DrugType',
  },
}

const drugExampleTagConfig: Partial<Record<IAutoCompleteType, IExampleTag>> = {
  ...baseExampleTagConfig,
  ADC_Antibody: {
    id: 'fcaf760bd0d54f5ca79c92ca47466fe7',
    display_name_en: 'Trastuzumab',
    display_name_cn: 'Trastuzumab',
  },
  ADC_Linker: {
    id: '0a9cafe3dc2d4ebcb121223dd0c2ab95',
    display_name_cn: 'SPDB',
    display_name_en: 'SPDB',
  },
  ADC_Payload: {
    id: '1c638a20aa7643b7a261c7bacb40d30a',
    display_name_cn: 'MMAE',
    display_name_en: 'MMAE',
  },
  Action: {
    id: '7c81609651d3455bb3b30ae33580b298',
    display_name_en: 'Antagonist',
    display_name_cn: '拮抗剂',
    icon: 'Action',
  },
  Mechanism: {
    id: '4dd338b149b3ecd0ee860e1fb379b44f',
    display_name_en: 'PD-1 inhibitors',
    display_name_cn: 'PD-1抑制剂',
    icon: 'Mechanism',
  },
  ATC: {
    id: '4081257f66244b44bbf0914abc3ac0a7',
    display_name_en: 'trastuzumab',
    display_name_cn: '曲妥珠单抗',
    atc_code: 'L01XC03',
    icon: 'Tree',
    search_strategy: 'ID_ROLLUP',
  },
  V_DELIVERY_SYSTEM: {
    id: 'cebfbf5158294267badc32e9c9619992',
    display_name_en: 'GalNAc',
    display_name_cn: 'GalNAc',
  },
  V_TARGETED_TISSUE: {
    id: 'a63a02bf5b3f433aa7da4ea6edd802bf',
    display_name_en: 'Hepatocytes',
    display_name_cn: '肝脏细胞',
  },
  V_REGULATION_TYPE: {
    id: '5f8ebace361f4fd5aa69b929a5284710',
    display_name_en: 'DNA-binding inhibition',
    display_name_cn: 'DNA-binding inhibition',
  },
  V_PAIRED_REGION: {
    id: '38fd06d2b2e7474ea3b4b832d36fddf3',
    display_name_en: 'Exon',
    display_name_cn: 'Exon',
  },
  TECH_PLATFORM: {
    id: '3d27d640ffd641e7b975d3168cf96722',
    display_name_en: 'Decoy oligonucleotide platform',
    display_name_cn: 'Decoy oligonucleotide platform',
  },
  MODIFICATION_ID: {
    id: '9',
    display_name_en: '5-Methyluridine',
    display_name_cn: '5-Methyluridine',
    icon: 'Modification',
  },
}

const clinicalExampleTagConfig: Partial<Record<IAutoCompleteType, IExampleTag>> = {
  ...baseExampleTagConfig,
  Mechanism: {
    id: '4dd338b149b3ecd0ee860e1fb379b44f',
    display_name_en: 'PD-1 inhibitors',
    display_name_cn: 'PD-1抑制剂',
    icon: 'Mechanism',
  },
  StudyCode: {
    id: 'DESTINY-Breast04',
    display_name_en: 'DESTINY-Breast04',
    display_name_cn: 'DESTINY-Breast04',
  },
  DosageForm: {
    id: 'de7a2bfa9e5e4163b84ce4bc9c196796',
    display_name_en: 'Solution For Injection',
    display_name_cn: '注射液',
  },
  RouteOfAdministration: {
    id: '7df72d13e81c4fc288da80b44cbed599',
    display_name_en: 'Injection',
    display_name_cn: '注射给药',
  },
}
const clinicalResultExampleTagConfig: Partial<Record<IAutoCompleteType, IExampleTag>> = {
  ...baseExampleTagConfig,
  Mechanism: {
    id: '4dd338b149b3ecd0ee860e1fb379b44f',
    display_name_en: 'PD-1 inhibitors',
    display_name_cn: 'PD-1抑制剂',
    icon: 'Mechanism',
  },
  Outcome: {
    id: 'b5929508886148bd899ab4def0451571',
    display_name_en: 'OS',
    display_name_cn: 'OS',
  },
  StudyCode: {
    id: 'DESTINY-Breast04',
    display_name_en: 'DESTINY-Breast04',
    display_name_cn: 'DESTINY-Breast04',
  },
}

const drugDealExampleTagConfig: Partial<Record<IAutoCompleteType, IExampleTag>> = {
  ...baseExampleTagConfig,
  Drug: {
    id: '81364d1ace044fdc8af8f60026eb2c7b',
    display_name_en: 'Ciltacabtagene autoleucel',
    display_name_cn: '西达基奥仑赛',
    icon: 'Drug',
  },
  Mechanism: {
    id: '4dd338b149b3ecd0ee860e1fb379b44f',
    display_name_en: 'PD-1 inhibitors',
    display_name_cn: 'PD-1抑制剂',
    icon: 'Mechanism',
  },
}

const translationalMedicineExampleTagConfig: Partial<Record<IAutoCompleteType, IExampleTag>> = {
  ...baseExampleTagConfig,
  Core: {
    display_name_en: 'PD-1',
    display_name_cn: 'PD-1',
  },
  Target: {
    id: 'd1539f818236424389b4326aa64702d8',
    display_name_en: 'SOD1',
    display_name_cn: 'SOD1',
  },
  Mechanism: {
    id: '4dd338b149b3ecd0ee860e1fb379b44f',
    display_name_en: 'PD-1 inhibitors',
    display_name_cn: 'PD-1抑制剂',
    icon: 'Mechanism',
  },
}

const patentExampleTagConfig: Partial<Record<IAutoCompleteType, IExampleTag>> = {
  ...baseExampleTagConfig,
  Drug: {
    id: '86b71230b00e49f6a2b1a9ae661db324',
    display_name_en: 'Ibrutinib',
    display_name_cn: '伊布替尼',
    icon: 'Drug',
  },
  Core: {
    display_name_en: 'PD-1',
    display_name_cn: 'PD-1',
  },
}

const literatureExampleTagConfig: Partial<Record<IAutoCompleteType, IExampleTag>> = {
  ...baseExampleTagConfig,
  Core: {
    display_name_en: 'PD-1',
    display_name_cn: 'PD-1',
  },
}

const CompetitiveExampleTagConfig: Record<Extract<IAutoCompleteType, 'Target' | 'Disease' | 'DrugType'>, IExampleTag[]> = {
  Target: [
    {
      id: '9786d32e3d244a688ec6a60d2fe1b10b',
      display_name_en: 'PD-1',
      display_name_cn: 'PD-1',
      icon: 'Target',
      itemType: 'Target',
    },
    {
      id: 'b6b70c7951c749e4a0420bad1ddc0808',
      display_name_en: 'LAG3',
      display_name_cn: 'LAG3',
      icon: 'Target',
      itemType: 'Target',
    },
  ],
  Disease: [baseExampleTagConfig.Disease],
  DrugType: [baseExampleTagConfig.DrugType],
}
const relationshipTagConfig: Partial<Record<IAutoCompleteType, IExampleTag | IExampleTag[]>> = {
  ...baseExampleTagConfig,
  Target: [
    {
      id: 'd9ded8f23b4140a5828314a55d2d66b4',
      display_name_en: 'KRAS',
      display_name_cn: 'KRAS',
      icon: 'Target',
      itemType: 'Target',
    },
    {
      id: '9786d32e3d244a688ec6a60d2fe1b10b',
      display_name_en: 'PD-1',
      display_name_cn: 'PD-1',
      icon: 'Target',
      itemType: 'Target',
    },
  ],
  Core: [
    {
      id: '11ef8a9e8bf5ca80213a1183511cded3',
      display_name_en: 'Amgen, Inc.',
      display_name_cn: '安进',
      itemType: 'Organization',
    },
    {
      id: '2838b95ade834c96b17ac8bcd2b68c27',
      display_name_en: 'Sotorasib',
      display_name_cn: '索托拉西布',
      icon: 'Drug',
      itemType: 'Drug',
    },
    {
      id: '928facc8122849baa0dc00759cff0380',
      display_name_en: 'KRAS G12C',
      display_name_cn: 'KRAS G12C',
      icon: 'Target',
      itemType: 'Target',
    },
  ],
}

export const exampleTagConfigMap: Record<IExampleConfigKey, Partial<Record<IAutoCompleteType, IExampleTag>>> & {
  RelationshipFinder: Partial<Record<IAutoCompleteType, IExampleTag | IExampleTag[]>>
  Competitive: Record<Extract<IAutoCompleteType, 'Target' | 'Disease' | 'DrugType'>, IExampleTag[]>
} = {
  DrugFinder: drugExampleTagConfig,
  ClinicalFinder: clinicalExampleTagConfig,
  ClinicalResultFinder: clinicalResultExampleTagConfig,
  PatentFinder: patentExampleTagConfig,
  LiteratureFinder: literatureExampleTagConfig,
  Competitive: CompetitiveExampleTagConfig,
  RelationshipFinder: relationshipTagConfig,
  DrugDealFinder: drugDealExampleTagConfig,
  TranslationalMedicineFinder: translationalMedicineExampleTagConfig,
}
